import { AutoStack } from 'components'
import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStackItem, FormStack } from 'forms/FormStack'
import { GlobalSettingType } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface SingleValueOptionFormType {
  type: GlobalSettingType
  value: string
}

export const SingleValueOptionForm: React.FC = () => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStackItem
        name="value"
        render={(fieldProps) => (
          <AutoStack tokens={{ childrenGap: 16 }}>
            <Label>
              {t(`enum.keywordType.${fieldProps.form.values.type}`)}
            </Label>
            <FormikTextField {...fieldProps} />
          </AutoStack>
        )}
      />
    </FormStack>
  )
}
